import React from "react";
import Alert from "react-bootstrap/Alert";
import "../../Pages/style/PageLogin.css";

export const LoginError = ({ error, title }) => {
  if (!error) return null;

  return (
    <Alert className="api-error-alert">
      <div className="d-flex align-items-start">
        <div className="me-2">
          <h5>{title}</h5>
        </div>
      </div>
      <div className="mt-1">
        <ul>
          <li>{error}</li>
        </ul>
      </div>
    </Alert>
  );
};
